// IE 2026 10 30 / ODOO-349799 (заказ Игоря: кнопка Graph вкладки Addons настроек): ответ бэка {'command':'updateDoc', ..., 'selectTab': '<вкладка>'}
// переключает активную вкладку панели виджета, даже если пользователь уже кликал по вкладкам (activeTab_apply после клика не срабатывает,
// selectTab читался только при widget_open). Чистая часть без Vue: какая панель, какая вкладка, и цепочка родительских вкладок для вложенной
// панели. Идентификатор — name, затем title, затем tooltip (как widget_activeTab / tabFind). Флаг fe.ux.selectTabFromBackend (дефолт ВКЛ).
// Тест: tests/unit/selectTab.test.mjs
export const SELECT_TAB_FLAG = 'fe.ux.selectTabFromBackend'

export function selectTab_on(setting) {
    try { return typeof setting !== 'function' || setting(SELECT_TAB_FLAG, true) !== false } catch (e) { return true }
}

// индекс видимой вкладки по идентификатору: name → title → tooltip; нет — -1. tabs: [{name, title, tooltip, visible}]
export function selectTab_find(tabs, ident) {
    if (typeof ident !== 'string' || !ident || !Array.isArray(tabs)) return -1
    for (const key of ['name', 'title', 'tooltip']) {
        const idx = tabs.findIndex(t => t && t.visible !== false && t[key] && t[key] === ident)
        if (idx >= 0) return idx
    }
    return -1
}

// panels: [{id, tabs, parentId?, parentTab?}] — parentId/parentTab: панель, в чьей вкладке (индекс) лежит эта; null — главная.
// Результат: шаги [{id, index}] от внешней панели к внутренней (родительские вкладки первыми); [] — не найдено.
// Из нескольких подходящих панелей берётся наименее вложенная (главная раньше вложенных), при равенстве — первая по порядку.
export function selectTab_plan(panels, ident) {
    if (!Array.isArray(panels) || !panels.length) return []
    const byId = new Map(panels.map(p => [p.id, p]))
    const chain = (p) => {   // шаги родителей снаружи внутрь; цикл или потерянный родитель — цепочка обрывается
        const steps = []
        const seen = new Set([p.id])
        let cur = p
        while (cur.parentId != null && Number.isInteger(cur.parentTab) && cur.parentTab >= 0) {
            const par = byId.get(cur.parentId)
            if (!par || seen.has(par.id)) break
            seen.add(par.id)
            steps.unshift({ id: par.id, index: cur.parentTab })
            cur = par
        }
        return steps
    }
    let best = null
    for (const p of panels) {
        const index = selectTab_find(p.tabs, ident)
        if (index < 0) continue
        const parents = chain(p)
        if (!best || parents.length < best.parents.length) best = { p, index, parents }
    }
    return best ? [...best.parents, { id: best.p.id, index: best.index }] : []
}
